module.exports = __webpack_public_path__ + "static/media/img_flipCards-09.55c02096.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-09.png
// module id = 444
// module chunks = 4